import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import {
  selectIsLoggedIn,
  selectRole,
  selectIsRefreshing,
} from "../redux/auth/authSelectors";

export const RoleRoute = ({
  component: Component,
  allowedRoles = [1, 2],
  redirectTo = "/login",
}) => {
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const isRefreshing = useSelector(selectIsRefreshing);
  const role = useSelector(selectRole);

  if (isRefreshing) return null;

  if (!isLoggedIn) return <Navigate to="/login" />;

  if (!allowedRoles.includes(role)) return <Navigate to={redirectTo} />;

  return <Component />;
};
